import {types} from '../../types';

const setGetSupportListAction = (payload) => {
    return {
        type: types.support.SET_SUPPORT_LIST,
        payload,
      }
}

const setGetSupportViewAction = (payload) => {
  return {
    type: types.support.SET_SUPPORT_VIEW,
    payload
  }
}

export {
  setGetSupportListAction as SetGetSupportListAction,
  setGetSupportViewAction as SetGetSupportViewAction
}
